import { Link } from "react-router-dom";
import "../css/footer.css";


export default function Footer() {
   return (
      <footer>
         <div>
            <Link to='/guides'>Guides</Link>
            <Link to='/download'>Download</Link>
            <Link to='/admin'>Dashboard</Link>
            <Link to='/search'>Search</Link>
            <Link to='/docs'>Docs</Link>
            <Link to='/docs#introduction'>Introduction</Link>
            <Link to='/docs#crud'>CRUD</Link>
            <Link to="https://buymeacoffee.com/chrisaxxwell" target="_blank">Buy me a coffee ☕️</Link>
         </div>

         <span>Developed by: <a href='https://chrisaxxwell.com' target="_blank" rel="noreferrer">@chrisaxxwell</a></span>
         <p>Copyright © {(new Date().getFullYear())} MerlinDB says 'Alakazam'. All rights reserved.</p>
      </footer>
   )
}